import React, { useState } from "react";
import "../sign-up/sign-up.css";
import "./reset-password.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../assets/images/vct_technologies_logo_dark-xl.png";
import LogoV from "../../../assets/images/vct-technologies-logo-v.png";
import { ResetPasswordAPI } from "api-services";
import { CircularProgress, Icon } from "@mui/material";
function ResetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();

  const token = new URLSearchParams(search).get("token");

  const loading = useSelector((state) => state.authentication.loading);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");

  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");

  //   Form validation
  const [errors, setErrors] = useState({});

  //   Setting button text
  const buttonText = "Reset Password";
  const [showPasswordError, setShowPasswordError] = useState(false);

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;
    setShowErrorMessage("");
    if (password.length <= 0) {
      tempErrors["password"] = true;
      isValid = false;
    }

    if (confirmPassword.length <= 0) {
      tempErrors["confirmPassword"] = true;
      isValid = false;
    }

    if (password != confirmPassword) {
      setShowErrorMessage("Your Passwords Don't Match!");
      isValid = false;
    }

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_+=!*()@%&]).{12,}$/;
    if (password.length > 0 && !regex.test(password)) {
      tempErrors["password_regex"] =
        "Password must be alphanumeric and at least 12 characters long, including one uppercase letter and a special character.";
      isValid = false;
    }

    if (confirmPassword.length > 0 && !regex.test(confirmPassword)) {
      tempErrors["confirm_password_regex"] =
        "Password must be alphanumeric and at least 12 characters long, including one uppercase letter and a special character.";
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };
  const handleForgetPassword = (e) => {
    e.preventDefault();
    let data = {
      newPassword: password,
      token: token,
    };

    if (handleValidation()) {
      ResetPasswordAPI(
        dispatch,
        data,
        navigateToDashboard,
        setShowErrorMessage,
        clearFields
      );
    }
  };

  const togglePasswordType = () => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const toggleConfirmPasswordType = () => {
    if (confirmPasswordType == "password") {
      setConfirmPasswordType("text");
    } else {
      setConfirmPasswordType("password");
    }
  };

  const navigateToDashboard = () => {
    setShowSuccessMessage(true);
    setTimeout(() => navigate("/authentication/sign-in"), 1000);
  };
  const clearFields = () => {
    setPassword("");
    setConfirmPassword("");
  };
  return (
    <div>
      <div className="wrap-register sigin">
        <div className="container-fluid text-center">
          <div className="row">
            <div className="col-md-6 p-0">
              <div className="bg-common">
                <div className="text-start cred">
                  <Link to="/">
                    <img
                      src={Logo}
                      alt="VCT Technologies LLC"
                      className="cred-logo"
                    />
                  </Link>
                  <h1 className="cred-title ps-2">Welcome Back!</h1>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-5 bg-trans">
              <div className="row justify-content-md-center">
                <div className="col-md-12 col-lg-6 p-lg-5">
                  <Link to="/">
                    <img
                      src={LogoV}
                      className="cred-logo"
                      alt="VCT Technologies LLC"
                    />
                  </Link>
                  <h3 className="cred-form-title text-start">Reset Password</h3>
                  <p className="cred-form-desc text-start">
                    Remember your password?
                    <Link to="/authentication/sign-in"> Sign In</Link>
                  </p>
                  <form className="row" onSubmit={handleForgetPassword}>
                    <div className="col-12 mb-3">
                      {/* <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="New Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        /> */}

                      <div className="password-field">
                        <input
                          type={passwordType}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="New Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                        <Icon
                          className={
                            errors?.password_regex
                              ? "password-input-icon padding-password-input-icon"
                              : "password-input-icon"
                          }
                          onClick={togglePasswordType}
                        >
                          {passwordType == "password"
                            ? "visibility"
                            : "visibility_off"}
                        </Icon>
                        {errors?.password_regex ? (
                          <Icon
                            className="password-input-icon red"
                            onMouseEnter={() => {
                              setShowPasswordError(true);
                            }}
                            onMouseLeave={() => {
                              setShowPasswordError(false);
                            }}
                            onClick={togglePasswordType}
                          >
                            info_outlined
                          </Icon>
                        ) : (
                          <></>
                        )}
                        {showPasswordError && (
                          <div className="absolute-err">
                            <div className="col-md-12 error-box">
                              <p className="text-red">
                                {errors?.password_regex}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      {errors?.password && (
                        <p className="text-red">
                          New Password cannot be empty.
                        </p>
                      )}
                    </div>
                    <div className="col-12 mb-3">
                      {/* <input
                          type="password"
                          className="form-control"
                          id="confirm-password"
                          placeholder="Confirm Password*"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                        /> */}

                      <div className="password-field">
                        <input
                          type={confirmPasswordType}
                          className="form-control"
                          id="confirm-password"
                          name="confirm-password"
                          placeholder="Confirm New Password*"
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                          }}
                        />
                        <Icon
                          className="password-input-icon"
                          onClick={toggleConfirmPasswordType}
                        >
                          {confirmPasswordType == "password"
                            ? "visibility"
                            : "visibility_off"}
                        </Icon>
                        {/* {errors?.confirm_password_regex ? (
                            <Icon
                              className="password-input-icon red"
                              onMouseEnter={() => {
                                setShowPasswordError(true);
                              }}
                              onMouseLeave={() => {
                                setShowPasswordError(false);
                              }}
                              onClick={togglePasswordType}
                            >
                              info_outlined
                            </Icon>
                          ) : (
                            <></>
                          )} */}
                      </div>
                      {errors?.confirmPassword && (
                        <p className="text-red">
                          Confirm New Password cannot be empty.
                        </p>
                      )}
                    </div>

                    <div className="d-grid gap-2 col-12 mx-auto mb-3">
                      {showErrorMessage != "" && (
                        <p className="text-error text-center">
                          {showErrorMessage}
                        </p>
                      )}
                      {showSuccessMessage && (
                        <p className="text-green text-center success">
                          Your password has been reset successfully! <br />{" "}
                          <Link to="/authentication/sign-in">Sign In</Link>.
                        </p>
                      )}
                      <button
                        className="btn cred-btn-contact justify-content-center"
                        onClick={handleForgetPassword}
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress
                            size={25}
                            color="white"
                            className="loaderbtn"
                          />
                        ) : (
                          buttonText
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="footer row justify-content-md-center">
                  <div className="col-md-12 col-lg-9 bg-trans p-0">
                    <div className="wrap-footer-inners">
                      <hr />
                      <Link to="/privacypolicy" target="_blank">
                        Privacy Policy
                      </Link>
                      <Link to="/termsofuse" target="_blank">
                        Terms of Use
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
